import './LoginSms.scss';

import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { mfaInit } from 'actions/authentication';
import Button from 'atoms/button';
import Dropdown from 'atoms/dropdown';
import Input from 'atoms/input';

export default function LoginInfo() {
  const dispatch = useDispatch();
  const countryIdOptions = useSelector((state) => state.main.geo.countryCode);

  const onLogIn = (e) => {
    e.preventDefault();
    dispatch(mfaInit({}));
  };

  return (
    <div className="login-sms">
      <h1>Forgot password</h1>
      <form onSubmit={onLogIn}>
        <div className="phone-container">
          <Dropdown
            id="countryCode"
            label="Phone"
            className="country-code-input"
            items={countryIdOptions}
            onClick={() => {}}
            value=""
          />
          <Input id="phone" className="no-label" onClick={() => {}} value="" />
        </div>
        <span className="no-account-text">
          Don&apos;t have an account?
          <Link to="/signup">Sign up.</Link>
        </span>
        <Button type="submit" text="Log in" />
      </form>
    </div>
  );
}
